export const API_URL = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL
   //: : "https://zikaron-be-prod.herokuapp.com";
  // : "https://zikaron-be.herokuapp.com"
  :  "https://dev.zikaronbasalon.com";
export const FE_URL = "https://app.zikaronbasalon.com";
